import type { Relation } from './relations';

/**
 * Порядок отбора кандидатов: меньше — раньше. Это продуктовое решение, а не
 * свойство соционики: менять порядок — переставить строки здесь.
 * Первые восемь считаются благоприятными, последние восемь — напряжёнными.
 */
const ORDER: readonly Relation[] = [
  'dual',
  'activation',
  'semiDual',
  'mirror',
  'identical',
  'business',
  'mirage',
  'kindred',
  'benefactor',
  'beneficiary',
  'supervisor',
  'supervisee',
  'quasiIdentical',
  'superEgo',
  'extinguishment',
  'conflict',
];

const RANK: ReadonlyMap<Relation, number> = new Map(ORDER.map((rel, i) => [rel, i + 1]));

export function relationRank(rel: Relation): number {
  return RANK.get(rel) ?? ORDER.length + 1;
}

export function compareByRelation(a: Relation, b: Relation): number {
  return relationRank(a) - relationRank(b);
}
